import { render, staticRenderFns } from "./UserCopyValue.vue?vue&type=template&id=020c2afc&scoped=true&"
import script from "./UserCopyValue.vue?vue&type=script&lang=js&"
export * from "./UserCopyValue.vue?vue&type=script&lang=js&"
import style0 from "./UserCopyValue.vue?vue&type=style&index=0&id=020c2afc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c2afc",
  null
  
)

export default component.exports